import styled from 'styled-components/macro';
import type { Role } from 'types';
import {
  reviewerCommentBackground,
  compilerCommentBackground,
} from 'utils/colors';

interface StyledCommentContainerProps {
  role?: Role;
}

export const CommentContainer = styled.div`
  margin-bottom: 8px;
  width: 100%;
  padding: 12px;
  box-sizing: border-box;
  border-radius: 4px;
`;
export const StyledCommentContainer = styled(
  CommentContainer
)<StyledCommentContainerProps>`
  background-color: ${({ role }) =>
    role === 'reviewer'
      ? reviewerCommentBackground
      : compilerCommentBackground};
`;
